export const environment = {
  production: false,
  auth0: 
  {
    domain: 'bruised-ears-dev.au.auth0.com',
    clientId: 'vdJno42C2KDcjOLiM9NKoRpguZsrFwMX',
    authorizationParams: {
      redirect_uri: window.location.origin + '/callback',
      audience: 'https://dev.api.bruisedears.com/app',
      scope: 'openid profile email',
    },
    errorPath: '/error',
  },
  api: 
  {
    backendUrl: 'https://dev.api.bruisedears.com/app/v1',
  }
};
